import { render, staticRenderFns } from "./OotdEpisode2.vue?vue&type=template&id=2b346cb7&"
import script from "./OotdEpisode2.vue?vue&type=script&lang=js&"
export * from "./OotdEpisode2.vue?vue&type=script&lang=js&"
import style0 from "./OotdEpisode2.vue?vue&type=style&index=0&id=2b346cb7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports